import theme from "../../muiTheme";
import { flexCentered, flexRowCentered } from "../../styles";

const styles = {

    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    imagePreviewContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    imagePreview: {
        borderRadius: '20px',
        objectFit: 'cover',
        maxWidth: '200px',
        maxHeight: '40vh',
        marginTop: '10px',
        marginBottom: '30px',
        boxShadow: '0 0 8px rgba(0,0,0,0.2)'
    },

    //crop styles
    cropRoot: {
        height: '80vh',
        width: '90vw',
        maxWidth: '1000px',
        boxSizing: 'border-box',
        background: 'white',
        padding: '20px 60px',
        borderRadius: '15px',
        position: 'relative', 
        zIndex: '2000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            width: '100vw',
            height: '100vh',
            borderRadius: '0px',
            padding: '30px 0px',
        },
    },
    cropContainer: {
        position: 'relative',
        width: '100%',
        height: '50%',
        background: '#333',
        borderRadius: '15px',
        boxShadow: 'rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px',

        '& div.reactEasyCrop_Container': {
            borderRadius: '15px',
            [theme.breakpoints.down('sm')]: {
                borderRadius: '0px'
            }
        },

        [theme.breakpoints.down('sm')]: {
            height: '60%',
            borderRadius: '0px',
        },
    },
    cropButton: {
        flexShrink: 0,
        maxWidth: '200px'
    },
    controls: {
        padding: '20px',
        display: 'flex',
        width: '50%',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '50px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'center',
            width: '90%',
            minWidth: '90%',
            marginTop: '30px',
            padding: '10px'
        },
    },
    sliderContainer: {
        display: 'flex',
        width: '90%',
        alignItems: 'center',
        margin: '5px'
    },
    sliderLabel: {

        marginRight: '10px',
        [theme.breakpoints.down('xs')]: {
            minWidth: 65,
        },
    },
    slider: {
        padding: '22px 0px',
        marginLeft: 32,
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignItems: 'center',
            margin: '0 16px',
        },
    },

    formButton: {
        marginRight: '20px',
        padding: '20px 20px',
        minWidth: '10px',
        minWidth: '60px',
        height: '60px',
        transition: '0.3s',
        ...flexRowCentered,

        [theme.breakpoints.down('sm')]: {
          padding: '0px 0px',
          border: '3px solid white'
        },

        '& span': {
            opacity: 0,
            width: '0px',
            height: 'auto',
            overflowX: 'hidden',
            transition: '0.3s',
        },

        '&:hover':{

            //width: '120px',

            '& span': {
                opacity: 1,
                width: '60px',
                marginLeft: '5px'
            }
        }
      },
      cropToggle: {
        marginRight: '20px',
        padding: '15px 15px',
        minWidth: '10px',
        minWidth: '45px',
        height: '46px',
        transition: '0.3s',
        marginLeft: '20px',
        ...flexRowCentered,

        [theme.breakpoints.down('sm')]: {
          padding: '0px 0px',
          //border: '3px solid white'
        },

        '& span': {
            opacity: 0,
            width: '0px',
            height: 'auto',
            overflowX: 'hidden',
            transition: '0.3s',
        },

        '&:hover':{

            //width: '120px',

            '& span': {
                
                [theme.breakpoints.up('md')]: {
                    opacity: 1,
                    width: '60px',
                    marginLeft: '5px',
                },
            },
            
        }
      }

}

export default styles; 